<template>
  <section v-cloak id="alert-banner" class="no-padding">
    <div class="container">
      <div class="row">
        <div
          v-for="(warning, index) in shownBanners"
          :key="index"
          class="small-12 columns banner-text"
        >
          <div class="close-banner icon-cross" @click="createBannerCookie(index)" />
          <p
            class="text-warning red alert-text"
            @click="checkElmOnClick($event, index)"
            v-html="warning.AlertText"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'AlertBanner',
  props: {
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      cookieName: 'closeBannersCookie=',
      shownBanners: this.options,
      bannersToHide: []
    };
  },
  mounted() {
    this.getBannerCookie();
    this.shownBanners.forEach((element) => {
      this.dispatchTrackingInfo(element.AlertBannerType, 'shown');
    });
  },
  methods: {
    // Triggers the dispatch event in store. Takes the content to include, and the tracking event
    dispatchTrackingInfo(content, trackEvent) {
      this.$store.dispatch('Events/register', {
        event: 'alert-banner-' + trackEvent,
        id: 'notifications',
        vm: content
      });
    },
    // Checks which element is being called on click, and only tracks the click on the link
    checkElmOnClick(event, index) {
      const elm = event.target.localName;
      const bannerType = this.shownBanners[index].AlertBannerType;

      if (elm === 'a') {
        return this.dispatchTrackingInfo(bannerType, 'clicked');
      }
      return elm;
    },
    // Creates a session cookie with banner IDs when a banner is closed
    createBannerCookie(index) {
      let stringifyArray;
      let bh = this.bannersToHide;
      let bannerId = this.shownBanners[index].AlertBannerID;

      bh.push(bannerId);
      stringifyArray = JSON.stringify(bh);
      document.cookie = this.cookieName + stringifyArray;
      this.setBanners();
      return bannerId;
    },
    // Checks for a cookie with name matching ours. If the cookie is found, it retrieves the cookie data.
    getBannerCookie() {
      const name = this.cookieName;
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(';');
      for (let i = 0; i < cookieArray.length; i++) {
        let c = cookieArray[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          let bannersFromCookie = c.substring(name.length, c.length);
          const parsedBanners = JSON.parse(bannersFromCookie);

          this.bannersToHide = parsedBanners;
          this.setBanners();
          return parsedBanners;
        }
      }
      return true;
    },
    // Updates the array of banners based on data retrived from cookie, or when a cookie is created
    setBanners() {
      let i;
      let sb = this.shownBanners;
      const bh = this.bannersToHide;
      let bannersToShow = [];

      for (i = 0; i < sb.length; i++) {
        if (!this.doesArrayContain(bh, sb[i].AlertBannerID)) {
          bannersToShow.push(sb[i]);
        }
      }
      sb.splice(0, sb.length);
      for (i = 0; i < bannersToShow.length; i++) {
        sb.push(bannersToShow[i]);
      }
    },
    doesArrayContain(array, text) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] == text) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/all';

.banner-text {
  &:not(:last-child) {
    border-bottom: solid 1px $white;
  }
  display: inline-block;
}
.close-banner {
  color: $inactive-field-text;
  float: right;
  margin-top: 1em;
  font-size: inherit;
  cursor: pointer;
}
.alert-text {
  width: 97%;
  margin-top: rem-calc(15);
}
</style>
